<template>
    <div>
        <block v-if="loading"></block>
        <div class="background rounded-lg pl-3 pr-3">
            <br/>
            <v-tabs v-model="tab">
                <v-tab href="#1">Generación de Comprobantes</v-tab>
                <v-tab href="#2">Historial de comprobantes</v-tab>
                <v-tab href="#3">Descarga masiva de comprobantes</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" touchless>
                <v-tab-item value="1">
                    <br/>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-radio-group v-model="filter.typeData" class="ma-3">
                                <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                                <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>

                    <div class="mt-2">
                        <GeneralFilter 
                            class="mt-0" 
                            :breakline="true" 
                            :filterEndpoint="$API.liquidaciones.getInvoicesForLiquidationFiltering" 
                            :columnsFilterEndpoint="$API.liquidaciones.getInvoicesForLiquidationFiltering" 
                            :search="{ ...this.filter, showAllRecords: false }"
                            :columns.sync="filterColumns"
                            :advancedFilter="true"
                            prefix-column
                            @emptyFilter="clearFilter" 
                            @filtered="filterHandler" 
                            :isAutoScrolled="true"
                            @loading="changeLoading"
                            :showBranchSelector="true"
                            :showAllRecordsToggle="true"
                            :selectedBranch="selectedBranch"
                            :branches="branches"
                            :currentBranch="currentBranch"
                            @onBranchChange="onBranchChange"
                            :showAllRecords="showAllRecords"
                            @onShowAllRecordsChange="onShowAllRecordsChange"
                        >

                            <v-row class="mb-6 mt-2">
                                <v-col cols="12" md="12">
                                    <v-btn class="btn-save" @click="showFormDcl = !showFormDcl">
                                        Generar comprobante contable de liquidación
                                    </v-btn>
                                    &nbsp;
                                    <v-btn class="btn-save" @click="showFormCl = !showFormCl">
                                        Generar comprobante de liquidación
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <DxDataGrid :data-source="invoices" key-expr="ID_Invoice"
                                :scrolling="{ useNative: true }"    
                                :column-auto-width="true"
                                :paging="{ enabled: false }" 
                                @exporting="(e) => onExporting(e, 'invoices')"
                                style="max-height: 600px;"
                            >
                                <DxExport :enabled="true"/>
                                <!--DxPaging :page-size="10"/-->
                                <DxColumn :width="80" cell-template="show-template" caption="Contable"></DxColumn>
                                <DxColumn :width="80" cell-template="show-template2" caption="Liquidación"></DxColumn>
                                <DxColumn data-field="ID_Invoice" caption="ID" width="200px"></DxColumn>
                                <DxColumn cell-template="EstadoLiquidacion" width="120px" caption="Comp. Contable"></DxColumn>
                                <template #EstadoLiquidacion="{data}">
                                    <div
                                        :style="{
                                        backgroundColor: data.data.BIDR_EsDcl ? '#E8F5E9' : '#FFF3E0',
                                        color: data.data.BIDR_EsDcl === 'Generado' ? '#2E7D32' : '#EF6C00',
                                        padding: '4px 8px',
                                        borderRadius: '6px',
                                        textAlign: 'center',
                                        fontWeight: '600'
                                        }"
                                    >
                                        {{ data.data.BIDR_EsDcl ? "GENERADO" : "PENDIENTE" }}
                                    </div>
                                </template>
                                <DxColumn cell-template="EstadoLiquidacion2" width="120px" caption="Comp. Liquidación"></DxColumn>
                                <template #EstadoLiquidacion2="{data}">
                                    <div
                                        :style="{
                                        backgroundColor: data.data.BIDR_EsCl ? '#E8F5E9' : '#FFF3E0',
                                        color: data.data.BIDR_EsCl === 'Generado' ? '#2E7D32' : '#EF6C00',
                                        padding: '4px 8px',
                                        borderRadius: '6px',
                                        textAlign: 'center',
                                        fontWeight: '600'
                                        }"
                                    >
                                        {{ data.data.BIDR_EsCl ? "GENERADO" : "PENDIENTE" }}
                                    </div>
                                </template>
                                <DxColumn data-field="InvoiceDate" width="100px" caption="Fecha de la Factura"></DxColumn>
                                <DxColumn data-field="HorEmi" width="100px" caption="Hora de la Factura"></DxColumn>
                                <!-- <DxColumn cell-template="hor-emi" width="100px" caption="Hora de la Factura"></DxColumn> -->
                                <!--DxColumn data-field="IdentificacionHorEmi" width="100px" caption="Hora de la Factura"></DxColumn-->
                                <!-- <DxColumn cell-template="tipo-documento" caption="Tipo de Documento"></DxColumn>  -->
                                <DxColumn data-field="TipoDocumento" caption="Tipo de Documento"></DxColumn> 
                                <!--DxColumn data-field="IdentificacionTipoDteDesc" caption="Tipo de Documento"></DxColumn-->
                                <DxColumn data-field="ID_Customer" width="180px" caption="ID de Cliente o Negocio"></DxColumn>
                                <DxColumn data-field="VentaTerceroNit" caption="NIT vta. a cuenta de terceros"></DxColumn>
                                <DxColumn data-field="VentaTerceroNombre" caption="Titular vta. a cuenta de terceros"></DxColumn>
                                <DxColumn data-field="InvoiceName" caption="Nombre legal"></DxColumn>
                                <DxColumn data-field="InvoiceTotalPagarToShow" caption="Total de Factura"></DxColumn>
                                <DxColumn data-field="InvoiceStatusDescription" caption="Forma de pago"></DxColumn>
                                <DxColumn data-field="FeMhEstado" width="150px" caption="Estado"></DxColumn>
                                <!-- <DxColumn cell-template="tipo-ambiente"  width="150px" caption="Ambiente"></DxColumn> -->
                                <DxColumn data-field="AmbienteToShow" width="150px" caption="Ambiente"></DxColumn>
                                <DxColumn data-field="CodigoGeneracion" caption="Codigo Generación"></DxColumn>
                                <DxColumn data-field="NumeroControl" caption="Numero de Control"></DxColumn>
                                <DxColumn data-field="FullName" caption="Usuario"></DxColumn>
                                <DxColumn data-field="FullNameSeller" caption="Vendedor"></DxColumn>
                                <DxColumn data-field="SelloRecepcion" caption="Sello Recepcion"></DxColumn>
                                <!--DxColumn cell-template="add-nd-or-nc" caption=""></DxColumn-->
                                <template #show-template="{data}">
                                    <button v-if="!data.data.BIDR_EsDcl && !isSelected(data.data.ID_Invoice)" href="#" class="mx-1" @click="addToProccesInvoiceForLiquidation(data.data)">
                                        <v-icon color="primary">mdi-plus</v-icon>
                                    </button>
                                    <span v-else-if="isSelected(data.data.ID_Invoice)">
                                        <v-icon color="primary">mdi-check</v-icon>
                                    </span>
                                    <!--a href="#" class="mx-1" @click.prevent.stop="showInvoiceDetail(data)">
                                        <v-icon color="primary">mdi-eye</v-icon>
                                    </a-->
                                </template>
                                <template #show-template2="{data}">
                                    <button v-if="!data.data.BIDR_EsCl && !isSelected2(data.data.ID_Invoice)" href="#" class="mx-1" @click="addToProccesInvoiceForLiquidation2(data.data)">
                                        <v-icon color="success">mdi-plus</v-icon>
                                    </button>
                                    <span v-else-if="isSelected2(data.data.ID_Invoice)">
                                        
                                        <v-icon color="success">mdi-check</v-icon>
                                    </span>
                                    <!--a href="#" class="mx-1" @click.prevent.stop="showInvoiceDetail(data)">
                                        <v-icon color="primary">mdi-eye</v-icon>
                                    </a-->
                                </template>
                                <template #hor-emi="{data}">
                                    {{ data.data.IdentificacionHorEmi != null ? data.data.IdentificacionHorEmi : "" }}
                                    {{ data.data.InvoiceType === 'TCKS' ? formatDateToHour(data.data.SystemDateInsert) : "" }}
                                </template>
                                <template #tipo-documento="{data}">
                                    {{ data.data.IdentificacionTipoDteDesc != null ? data.data.IdentificacionTipoDteDesc : "" }}
                                    {{ data.data.InvoiceType === 'TCKS' ? "TICKET" : "" }}
                                </template>
                                <!--template #add-nd-or-nc="{data}">
                                    <v-btn v-if="data.data.FeMhEstado == 'PROCESADO' && data.data.InvoiceType == 'CCF'" class="mx-1 btn-save" 
                                    @click.prevent.stop="addNDorNC(data)" >
                                        Relacionar ND o NC
                                    </v-btn>
                                </template-->
                                <template #tipo-ambiente="{data}">
                                    {{ data.data.IdentificacionAmbiente == '00' ? "Prueba" : "" }}
                                    {{ data.data.IdentificacionAmbiente == '01' ? "Producción" : "" }}
                                </template>
                            </DxDataGrid>
                        </GeneralFilter>
                    </div>
                </v-tab-item>
                <v-tab-item value="2">
                    <br/>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-radio-group v-model="filter2.typeData" class="ma-3">
                                <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                                <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>

                    <div class="mt-2">
                        <GeneralFilter 
                            class="mt-0" 
                            :breakline="true" 
                            :filterEndpoint="$API.liquidaciones.getInvoicesLiquidationTypeFiltering" 
                            :columnsFilterEndpoint="$API.liquidaciones.getInvoicesLiquidationTypeFiltering" 
                            :search="{ ...this.filter2, showAllRecords: false }"
                            :advancedFilter="true"
                            prefix-column
                            :columns.sync="filterColumns2"
                            @emptyFilter="clearFilterLiquidations" 
                            @filtered="filterHandlerLiquidations" 
                            :isAutoScrolled="true"
                            @loading="changeLoading"
                            :showAllRecordsToggle="true"
                            :showAllRecords="showAllRecords"
                            @onShowAllRecordsChange="onShowAllRecordsChange"
                        >
                            <DxDataGrid :data-source="invoicesDclAndCl" key-expr="ID_Invoice"
                                :scrolling="{ useNative: true }"    
                                :column-auto-width="true"
                                :paging="{ enabled: false }" 
                                style="max-height: 600px;"
                                @exporting="(e) => onExporting(e, 'invoicesDclAndCl')"
                                @row-prepared="onRowPrepared"
                            >
                                <DxExport :enabled="true"/>
                                <!--DxPaging :page-size="10"/-->
                                <DxColumn :width="80" cell-template="show-template" caption=""></DxColumn>
                                <template #show-template="{ data }">
                                    <a href="#" class="mx-1" @click.prevent.stop="reloadPrint++; reloadPrintCl++; displayPrinter(data)">
                                        <v-icon>mdi-printer</v-icon>
                                    </a>
                                </template>
                                <DxColumn :width="100" data-field="FeMhEstado" caption="Estado"></DxColumn>
                                <DxColumn cell-template="show-template2" style="padding: 2px;" width="80px" caption="" :fixed="true" :fixed-position="'right'"></DxColumn>
                                <template #show-template2="{data}">
                                    <button style="height: 28px; font-size: 11px; background-color: red; color: #fff; padding: 4px 6px; border-radius: 6px;"
                                    @click.prevent.stop="displayInvalidForm(data.data)" >
                                        INVALIDAR
                                    </button>
                                </template>
                                <DxColumn data-field="ID_Invoice" caption="ID Factura" width="200px"></DxColumn>
                                <DxColumn cell-template="tipo-dte" width="270px" caption="Tipo de Factura"></DxColumn>
                                <template #tipo-dte={data}>
                                    <div>
                                        {{ data.data.IdentificacionTipoDte == '08' ? 'COMPROBANTE DE LIQUIDACIÓN' : '' }}
                                        {{ data.data.IdentificacionTipoDte == '09' ? 'COMPROBANTE CONTABLE DE LIQUIDACIÓN' : '' }}
                                    </div>
                                </template>
                                <DxColumn data-field="IdentificacionFecEmi" width="100px" caption="Fecha de la Factura"></DxColumn>
                                <DxColumn data-field="IdentificacionHorEmi" width="100px" caption="Hora de la Factura"></DxColumn>
                                <DxColumn data-field="IdentificacionCodigoGeneracion" caption="Codigo Generación"></DxColumn>
                                <DxColumn data-field="IdentificacionNumeroControl" caption="Numero de Control"></DxColumn>
                                <DxColumn data-field="ReceptorNombre" caption="Receptor"></DxColumn>
                                <DxColumn cell-template="total-liquidado" caption="Total liquidado"></DxColumn>
                                <template #total-liquidado="{ data }">
                                    <div> 
                                        {{ data.data.CuerpoDocumentoDclLiquidoPagar > 0 ? data.data.CuerpoDocumentoDclLiquidoPagar : "" }}
                                        {{ data.data.ResumenClTotal > 0 ? data.data.ResumenClTotal : "" }}
                                    </div>
                                </template>
                                <DxColumn cell-template="cantidad-doc" caption="Cantidad Doc."></DxColumn>
                                <template #cantidad-doc="{ data }">
                                    <div> 
                                        {{ data.data.CuerpoDocumentoDclCantidadDoc > 0 ? data.data.CuerpoDocumentoDclCantidadDoc : "" }}
                                        {{ data.data.CantidadAux > 0 ? data.data.CantidadAux : "" }}
                                    </div>
                                </template>
                                <DxColumn data-field="ExtensionNombEntrega" caption="Usuario que lo realizo"></DxColumn>
                            </DxDataGrid>
                        </GeneralFilter>
                    </div>
                </v-tab-item>
                <v-tab-item value="3">
                    <br/>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-radio-group v-model="filter.typeData" class="ma-3">
                                <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                                <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>

                    <div class="px-4 pb-4">
                        <v-expansion-panels v-model="downloadExpansionPanel" style="background: #fff;">
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <span class="text-h6">Descarga de archivos</span>
                                    <template v-slot:actions>
                                        <v-chip color="primary" small>
                                            {{ bulkInvoicesCount }} comprobantes
                                        </v-chip>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card rounded="lg">
                                        <v-card-text class="px-0 pt-0">
                                            <date-filter
                                                @filtered-data="bulkDateFilterHandler"
                                                @reset-data="resetBulkLiquidationInvoices"
                                                :dataToFilter="bulkLiquidationInvoices"
                                                :search="{ ...this.filter, showAllRecords: true }"
                                                nameOfDate="History"
                                                :filterEndpoint="$API.liquidaciones.getInvoicesLiquidationTypeFiltering"
                                                :isFilteredByOutsource="false"
                                            >
                                                <template #default="{ startDate: start, endDate: end }">
                                                    <PrintPdfLiquidacionesProgrammatic
                                                        :data="bulkLiquidationInvoices"
                                                        :startDate="start"
                                                        :endDate="end"
                                                    />
                                                </template>
                                            </date-filter>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </v-tab-item>
            </v-tabs-items>
            
        </div>

        <alerts style="z-index: 20000 !important;"
        v-if="alert.show"
        v-on:close_alert="closeAlert"
        v-on:accept_alert="acceptAlert"
        :properties="alert"
        >
        </alerts>
        <v-dialog v-model="showFormDcl" scrollable max-width="75%">
            <v-card> 
                <v-card-title>
                    Generación de comprobante contable de liquidación
                </v-card-title>
                <v-card-text>
                    <v-form ref="formLiquidacion">
                        <v-row class="mt-4 mb-4">
                            <v-col cols="12" md="3">
                                <date-picker
                                    label="Fecha de factura"
                                    v-model="formDcl.fechafactura"
                                    @dateSelected="(param) =>{ 
                                        formDcl.fechafactura = param;
                                    }"
                                    dense
                                >
                                </date-picker>
                            </v-col>
                            <v-col cols="12"  md="12" class="my-3" style="font-weight: bold;">
                                RESPONSABLE
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    label="Nombre"
                                    v-model="formDcl.username"
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.minLength(5), rules.maxLength(100)]"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    label="Número de Documento"
                                    v-model="formDcl.userdui"
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.minLength(5), rules.maxLength(25)]"
                                />
                            </v-col>

                            <v-col col="12"  md="12" class="my-3" style="font-weight: bold;">
                                INFORMACIÓN DEL RECEPTOR
                            </v-col>
                            <v-col cols="12">
                                <v-alert 
                                    v-model="alertDialog.show"
                                    :type="alertDialog.type" 
                                    dismissible
                                    >
                                    {{ alertDialog.message }}
                                </v-alert>
                            </v-col>
                            <v-col cols="12">
                                <CustomAutoComplete
                                    style="display: inline-block; width: calc(100%); vertical-align: top;"
                                    key="Customer"
                                    v-if="customersList.length > 0"
                                    :label="'Cliente'"
                                    v-model="formDcl.idcustomer"
                                    :search="{ ...search, filteredFrom: 2 }"
                                    :items="customersList"
                                    :item-text="'itemText'"
                                    :filter-endpoint="$API.customers.filterCustomers"
                                    :item-value="'ID_Customer'"
                                    @select="
                                    (e) => {
                                        formDcl.idcustomer = e;
                                        customerSelectOnchange(e);
                                    }
                                    "
                                    @updateItems="updateCustomersLIst"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    v-model="formDcl.tipoestablecimiento"
                                    outlined
                                    dense
                                    attach
                                    :items="[
                                        { key: '01', value: 'Sucursal / Agencia'},
                                        { key: '02', value: 'Casa matriz'},
                                        { key: '04', value: 'Bodega'},
                                        { key: '07', value: 'Predio y/o patio'},
                                        { key: '20', value: 'Otro'}
                                    ]"
                                    item-value="key"
                                    item-text="value"
                                    label="Tipo establecimiento"
                                    :rules="[rules.required]"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    label="NRC"
                                    v-model="formDcl.legalnrc"
                                    @keyup="getNRCMask" 
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.nrc, rules.minLength(1), rules.maxLength(8)]"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    label="NIT"
                                    v-model="formDcl.legalnit"
                                    @keyup="getNITMask"
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.nit]"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    outlined
                                    dense
                                    label="Actividad económica"
                                    :items="activities"
                                    @change="changueValueactivity"
                                    attach
                                    v-model="formDcl.codactividad"
                                    item-text="Valores"
                                    item-value="Codigo"
                                    :rules="[rules.required]"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="formDcl.receptorcodigomh"
                                    outlined
                                    dense
                                    label="Código MH"
                                    :rules="[rules.codigoMH]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="formDcl.receptorpuntoventamh"
                                    outlined
                                    dense
                                    label="Punto Venta MH"
                                    :rules="[rules.puntoVentaMH]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-if="formDcl.isa_business"
                                    label="Télefono"
                                    v-model="formDcl.businessphone"
                                    outlined
                                    dense
                                />
                                <v-text-field v-if="!formDcl.isa_business"
                                    label="Télefono"
                                    v-model="formDcl.phonenumber"
                                    outlined
                                    dense
                                    :rules="[rules.telefono]"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-if="formDcl.isa_business"
                                    label="Correo eléctronico"
                                    v-model="formDcl.businesscontactemail"
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.email, rules.maxLength(100)]"
                                />
                                <v-text-field v-if="!formDcl.isa_business"
                                    label="Correo eléctronico"
                                    v-model="formDcl.email"
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.email, rules.maxLength(100)]"
                                />
                            </v-col>

                            <v-col col="12" md="12" class="mb-3" style="font-weight: bold;">
                                DETALLE DEL COMPROBANTE
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.valoroperaciones"
                                    outlined
                                    dense
                                    @keyup="calculateOperation1()"
                                    type="number"
                                    label="Valor operaciones"
                                    :rules="[rules.required,rules.min(0.01), rules.max(100000000000)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-autocomplete
                                    v-model="formDcl.codigoliquidacion"
                                    outlined
                                    dense
                                    label="Código de liquidación"
                                    :items="[
                                        { key: '22', value: 'Retención IVA 2%'},
                                        { key: 'C4', value: 'Retención IVA 13%'},
                                        { key: 'C9', value: 'Otras retenciones IVA casos especiales'},
                                    ]"
                                    item-text="value"
                                    item-value="key"
                                    @change="selectCodigoLiquidacion"
                                    :rules="[rules.minLength(1), rules.maxLength(30)]"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.porcentajeretencioniva"
                                    outlined
                                    dense
                                    type="number"
                                    @keyup="selectCodigoLiquidacion"
                                    label="Porcentaje de retención %"
                                    :disabled="formDcl.codigoliquidacion !== 'C9'"
                                    :rules="[
                                        (v) => formDcl.codigoliquidacion !== 'C9' || !!v || 'Este campo es requerido cuando es tipo C9',
                                        rules.min(0),
                                        rules.max(100)
                                        ]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.cantidaddoc"
                                    outlined
                                    dense
                                    type="number"
                                    label="Cantidad doc"
                                    step="1"
                                    :rules="[rules.required,rules.min(1), rules.max(100000000000)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.subtotal"
                                    outlined
                                    dense
                                    @keyup="calculateOperation2()"
                                    type="number"
                                    label="SubTotal"
                                    step="0.01"
                                    :rules="[rules.required,rules.min(0), rules.max(100000000000)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.iva"
                                    outlined
                                    dense
                                    type="number"
                                    label="IVA"
                                    :rules="[rules.required,rules.min(0), rules.max(100000000000)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.montosujetopercepcionsiniva"
                                    outlined
                                    dense
                                    type="number"
                                    label="Monto sujeto perceción sin IVA"
                                    :rules="[rules.required,rules.min(0), rules.max(100000000000)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.ivapercibido"
                                    outlined
                                    dense
                                    type="number"
                                    label="IVA Percibido"
                                    :rules="[rules.required,rules.min(0), rules.max(100000000000)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.porcentajecomision"
                                    outlined
                                    dense
                                    type="number"
                                    @input="calculateComision()"
                                    label="Porcentaje de comisión %"
                                    :rules="[rules.required,rules.min(0), rules.max(100)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.comision"
                                    outlined
                                    dense
                                    @input="calculatePorcentajeComision()"
                                    type="number"
                                    label="Comisión"
                                    step="0.01"
                                    :rules="[rules.required,rules.min(0), rules.max(100000000000)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.ivacomision"
                                    outlined
                                    dense
                                    type="number"
                                    label="IVA Comisión"
                                    step="0.01"
                                    :rules="[rules.required,rules.min(0), rules.max(100000000000)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.liquidoapagar"
                                    outlined
                                    dense
                                    type="number"
                                    label="Liquido a pagar"
                                    step="0.01"
                                    :rules="[rules.required,rules.min(0), rules.max(100000000000)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.montosinpercepcion"
                                    outlined
                                    dense
                                    type="number"
                                    label="Monto sin percepción"
                                    step="0.01"
                                    :rules="[rules.required,rules.min(0), rules.max(100000000000)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formDcl.totalliquidar"
                                    outlined
                                    dense
                                    type="number"
                                    label="Total a liquidar"
                                    :rules="[rules.required, rules.min(0), rules.max(100000000000)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <date-picker
                                    label="Fecha"
                                    v-model="formDcl.periodoliquidacionfechainicio"
                                    @dateSelected="(param) =>{ 
                                        formDcl.periodoliquidacionfechainicio = param;
                                    }"
                                    dense
                                    >
                                </date-picker>
                            </v-col>
                            <v-col cols="12" md="3">
                                <date-picker
                                    label="Fecha"
                                    v-model="formDcl.periodoliquidacionfechafin"
                                    @dateSelected="(param) =>{ 
                                        formDcl.periodoliquidacionfechafin = param;
                                    }"
                                    dense
                                    >
                                </date-picker>
                            </v-col>
                            <v-col cols="12">
                                <h3>Facturas seleccionadas para la generacion del comprobante:</h3>
                            </v-col>
                            <DxDataGrid
                                :data-source="invoicesSelected"
                                :show-borders="true"
                                key-expr="ID_Invoice"
                                :scrolling="{ useNative: true }"    
                                :column-auto-width="true"
                                :paging="{ enabled: false }"
                            >
                                <DxColumn cell-template="show-template" caption=""/>
                                <template #show-template="{data}">
                                    <a href="#" @click="removeFromInvoicesToLiquidation(data.data)">
                                        <v-icon>mdi-delete</v-icon>
                                    </a>
                                </template>
                                <DxColumn caption="ID Factura" data-field="ID_Invoice" />
                                <DxColumn caption="Código Generación" data-field="CodigoGeneracion" />
                                <DxColumn caption="Total" cell-template="total" />
                                <template #total="{data}">
                                    ${{ (Math.round(parseFloat(data.data.InvoiceTotalPagar) * 100) / 100).toFixed(2) }}
                                </template>
                                <DxColumn data-field="InvoiceDate" width="100px" caption="Fecha de la Factura"></DxColumn>
                                <DxColumn data-field="HorEmi" width="100px" caption="Hora de la Factura"></DxColumn>
                            </DxDataGrid>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-col class="text-left">
                        <v-btn
                            @click="cleanData()"
                            class="btnclean mr-3"
                        >
                            Limpiar datos
                        </v-btn>
                        <v-btn
                            @click="createComprobanteContableLiquidacion()"
                            class="btn-save"
                        >
                            CREAR COMPROBANTE
                        </v-btn>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn
                            @click="showFormDcl = !showFormDcl"
                            class="btndisable"
                        >
                            Cerrar
                        </v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showFormCl" scrollable max-width="75%">
            <v-card> 
                <v-card-title>
                    Generación de comprobante de liquidación
                </v-card-title>
                <v-card-text>
                    <v-form ref="formLiquidacion2">
                        <v-row class="mt-4 mb-4">
                            <v-col cols="12" md="3">
                                <date-picker
                                    label="Fecha de factura"
                                    v-model="formCl.fechafactura"
                                    @dateSelected="(param) =>{ 
                                        formCl.fechafactura = param;
                                    }"
                                    dense
                                >
                                </date-picker>
                            </v-col>
                            <v-col col="12"  md="12" class="my-3" style="font-weight: bold;">
                                RESPONSABLE
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    label="Nombre"
                                    v-model="formCl.username"
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.minLength(5), rules.maxLength(100)]"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    label="Número de Documento"
                                    v-model="formCl.userdui"
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.minLength(5), rules.maxLength(25)]"
                                />
                            </v-col>

                            <v-col col="12"  md="12" class="my-3" style="font-weight: bold;">
                                INFORMACIÓN DEL RECEPTOR
                            </v-col>
                            <v-col cols="12">
                                <v-alert 
                                    v-model="alertDialog.show"
                                    :type="alertDialog.type" 
                                    dismissible
                                    >
                                    {{ alertDialog.message }}
                                </v-alert>
                            </v-col>
                            <v-col cols="12">
                                <CustomAutoComplete
                                    style="display: inline-block; width: calc(100%); vertical-align: top;"
                                    key="Customer"
                                    v-if="customersList.length > 0"
                                    :label="'Cliente'"
                                    v-model="formCl.idcustomer"
                                    :search="{ ...search, filteredFrom: 2 }"
                                    :items="customersList"
                                    :item-text="'itemText'"
                                    :filter-endpoint="$API.customers.filterCustomers"
                                    :item-value="'ID_Customer'"
                                    @select="
                                    (e) => {
                                        formCl.idcustomer = e;
                                        customerSelectOnchange2(e);
                                    }
                                    "
                                    @updateItems="updateCustomersLIst"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    v-model="formCl.tipoestablecimiento"
                                    outlined
                                    dense
                                    attach
                                    :items="[
                                        { key: '01', value: 'Sucursal / Agencia'},
                                        { key: '02', value: 'Casa matriz'},
                                        { key: '04', value: 'Bodega'},
                                        { key: '07', value: 'Predio y/o patio'},
                                        { key: '20', value: 'Otro'}
                                    ]"
                                    item-value="key"
                                    item-text="value"
                                    label="Tipo establecimiento"
                                    :rules="[rules.required]"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    label="NRC"
                                    v-model="formCl.legalnrc"
                                    @keyup="getNRCMask" 
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.nrc, rules.minLength(1), rules.maxLength(8)]"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    label="NIT"
                                    v-model="formCl.legalnit"
                                    @keyup="getNITMask"
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.nit]"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    outlined
                                    dense
                                    label="Actividad económica"
                                    :items="activities"
                                    @change="changueValueactivity"
                                    attach
                                    v-model="formCl.codactividad"
                                    item-text="Valores"
                                    item-value="Codigo"
                                    :rules="[rules.required]"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="formCl.receptorcodigomh"
                                    outlined
                                    dense
                                    label="Código MH"
                                    :rules="[rules.codigoMH]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="formCl.receptorpuntoventamh"
                                    outlined
                                    dense
                                    label="Punto Venta MH"
                                    :rules="[rules.puntoVentaMH]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-if="formCl.isa_business"
                                    label="Télefono"
                                    v-model="formCl.businessphone"
                                    outlined
                                    dense
                                />
                                <v-text-field v-if="!formCl.isa_business"
                                    label="Télefono"
                                    v-model="formCl.phonenumber"
                                    outlined
                                    dense
                                    :rules="[rules.telefono]"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-if="formCl.isa_business"
                                    label="Correo eléctronico"
                                    v-model="formCl.businesscontactemail"
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.email, rules.maxLength(100)]"
                                />
                                <v-text-field v-if="!formCl.isa_business"
                                    label="Correo eléctronico"
                                    v-model="formCl.email"
                                    outlined
                                    dense
                                    :rules="[rules.required, rules.email, rules.maxLength(100)]"
                                />
                            </v-col>

                            <v-col col="12" md="12" class="mb-3" style="font-weight: bold;">
                                DETALLE DEL COMPROBANTE
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formCl.totalnosuj"
                                    outlined
                                    dense
                                    type="number"
                                    label="Total No Sujeta"
                                    :rules="[rules.required,rules.min(0.01), rules.max(100000000000)]"
                                    :disabled="true"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formCl.totalexenta"
                                    outlined
                                    dense
                                    type="number"
                                    label="Total Exenta"
                                    :rules="[rules.required,rules.min(0.01), rules.max(100000000000)]"
                                    :disabled="true"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formCl.totalgravada"
                                    outlined
                                    dense
                                    type="number"
                                    label="Total Gravada"
                                    :rules="[rules.required,rules.min(0.01), rules.max(100000000000)]"
                                    :disabled="true"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formCl.subtotalventas"
                                    outlined
                                    dense
                                    type="number"
                                    label="Sub Total Ventas"
                                    :rules="[rules.required,rules.min(0.01), rules.max(100000000000)]"
                                    :disabled="true"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formCl.montototaloperacion"
                                    outlined
                                    dense
                                    type="number"
                                    label="Monto Total Operación"
                                    :rules="[rules.required,rules.min(0.01), rules.max(100000000000)]"
                                    :disabled="true"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formCl.ivaperci"
                                    outlined
                                    dense
                                    type="number"
                                    label="IVA Percibido"
                                    :rules="[rules.required,rules.min(0.01), rules.max(100000000000)]"
                                    :disabled="true"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="formCl.total"
                                    outlined
                                    dense
                                    type="number"
                                    label="Total"
                                    :rules="[rules.required,rules.min(0.01), rules.max(100000000000)]"
                                    :disabled="true"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                
                            </v-col>
                            <!--v-col cols="12" md="3">
                                <date-picker
                                    label="Fecha"
                                    v-model="formCl.periodoliquidacionfechainicio"
                                    @dateSelected="(param) =>{ 
                                        formCl.periodoliquidacionfechainicio = param;
                                    }"
                                    dense
                                    >
                                </date-picker>
                            </v-col>
                            <v-col cols="12" md="3">
                                <date-picker
                                    label="Fecha"
                                    v-model="formCl.periodoliquidacionfechafin"
                                    @dateSelected="(param) =>{ 
                                        formCl.periodoliquidacionfechafin = param;
                                    }"
                                    dense
                                    >
                                </date-picker>
                            </v-col-->
                            <v-col cols="12">
                                <h3>Facturas seleccionadas para la generacion del comprobante:</h3>
                            </v-col>
                            <DxDataGrid
                                :data-source="invoicesSelected2"
                                :show-borders="true"
                                key-expr="ID_Invoice"
                                :scrolling="{ useNative: true }"    
                                :column-auto-width="true"
                                :paging="{ enabled: false }"
                            >
                                <DxColumn cell-template="show-template" caption=""/>
                                <template #show-template="{data}">
                                    <a href="#" @click="removeFromInvoicesToLiquidation2(data.data)">
                                        <v-icon>mdi-delete</v-icon>
                                    </a>
                                </template>
                                <DxColumn caption="ID Factura" data-field="ID_Invoice" />
                                <DxColumn caption="Código Generación" data-field="CodigoGeneracion" />
                                <DxColumn caption="Total" cell-template="total" />
                                <template #total="{data}">
                                    ${{ (Math.round(parseFloat(data.data.InvoiceTotalPagar) * 100) / 100).toFixed(2) }}
                                </template>
                                <DxColumn data-field="InvoiceDate" width="100px" caption="Fecha de la Factura"></DxColumn>
                                <DxColumn data-field="HorEmi" width="100px" caption="Hora de la Factura"></DxColumn>
                            </DxDataGrid>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-col class="text-left">
                        <v-btn
                            @click="cleanData2()"
                            class="btnclean mr-3"
                        >
                            Limpiar datos
                        </v-btn>
                        <v-btn
                            @click="createComprobanteDeLiquidacion()"
                            class="btn-save"
                        >
                            CREAR COMPROBANTE
                        </v-btn>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn
                            @click="showFormCl = !showFormCl"
                            class="btndisable"
                        >
                            Cerrar
                        </v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <PrintLiquidaciones :data="print" :key="reloadPrint"></PrintLiquidaciones>
        <PrintLiquidacionesCl :data="print2" :key="reloadPrintCl"></PrintLiquidacionesCl>

        <v-dialog
            v-model="showInvalidAlert"
            :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '500px'"
        >
            <v-card class="text-center">
                <template>
                    <v-card-title class="text-h5">
                    ¿Esta seguro de invalidar esta factura?

                    <v-row class="mt-2">
                        <v-col cols="12">
                        <v-text-field
                        outlined
                        dense
                        v-model="invalidForm.motivoInvalid"
                        label="Motivo de invalidación"
                        ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                        <v-select
                        outlined
                        dense
                        attach
                        v-model="invalidForm.tipo"
                        :items="invalidForm.tipoInvalid"
                        item-text="value"
                        item-value="id"
                        label="Seleccione el tipo de invalidación"
                        >
                        </v-select>
                        </v-col>
                    </v-row>
                    </v-card-title>

                    <v-btn
                    class="ma-2"
                    large
                    color="info"
                    @click="invalidDTE(invalidForm)"
                    >
                    Invalidar
                    </v-btn>

                    <v-btn
                    class="ma-2"
                    large
                    color="error"
                    @click="showInvalidAlert = false"
                    >
                    Cancelar
                    </v-btn>
                </template>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { DxDataGrid, DxColumn, DxExport} from 'devextreme-vue/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Alerts from "@/components/Alerts";
import Block from "@/components/Block";
import GeneralFilter from '../../components/GeneralFilter.vue';
import DateFilter from '../../components/DateFilter.vue';
import Vue from "vue";
import CustomAutoComplete from "../../components/CustomAutoComplete.vue";
import { mapGetters } from "vuex";
import { numberWithCommas } from '../../helpers/money';
import { generateUUID } from "../../helpers/misc";
import PrintLiquidaciones from '../../components/ReportsAndPrintings/PrintLiquidaciones.vue';
import PrintLiquidacionesCl from '../../components/ReportsAndPrintings/PrintLiquidacionesCl.vue';
import PrintPdfLiquidacionesProgrammatic from '../../components/POS/PrintPdfLiquidacionesProgrammatic.vue';
import DatePicker from "../../components/DatePicker";
import { numberToText } from "@/helpers/conveterNumberText";
import {
    dui as duiMask,
    nrc as nrcMask,
    nitMaskHandlingHomologation,
} from "@/helpers/masks";
export default {
    name: "Liquidaciones",
    components: {
        DxDataGrid,
        DxColumn,
        Alerts,
        DxExport,
        GeneralFilter,
        DateFilter,
        Block,
        CustomAutoComplete,
        PrintLiquidaciones,
        PrintLiquidacionesCl,
        PrintPdfLiquidacionesProgrammatic,
        DatePicker
    },
    data() {
        return {
            loading: false,
            filter: {
                codPointSale: localStorage.getItem("codPointSale"),
                ID_Branch: JSON.parse(localStorage.getItem("user")).branch || "",
                ID_Business: JSON.parse(localStorage.getItem("user")).businessid || "" ,
                user: JSON.parse(localStorage.getItem("user")).id || "",
                typeData: '01',
                column_FeMhEstado: 'PROCESADO'
            },
            filter2: {
                // codPointSale: localStorage.getItem("codPointSale"),
                ID_Branch: JSON.parse(localStorage.getItem("user")).branch || "",
                ID_Business: JSON.parse(localStorage.getItem("user")).businessid || "" ,
                user: JSON.parse(localStorage.getItem("user")).id || "",
                typeData: '01',
                // column_FeMhEstado: 'PROCESADO'
            },
            selectedBranch: null,
            branches: [],
            bulkLiquidationInvoices: [],
            currentBranch: null,
            downloadExpansionPanel: 0,
            showAllRecords: false,
            tab: null,
            showFormDcl: false,
            showFormCl: false,
            isFiltered: false,
            isFiltered2: false,
            formDcl: {},
            formCl: {},
            customersList: [],
            invoicesSelected: [],
            invoicesSelected2: [],
            invoices: [],
            invoicesDclAndCl: [],
            search: {
                business: JSON.parse(localStorage.getItem("user")).businessid,
                branch: JSON.parse(localStorage.getItem("user")).branch, 
            },
            print: {
                show: false
            },
            print2: {
                show: false
            },
            filterType: [
                {
                    name: 'CRÉDITO FISCAL', key: 'CCF',
                }, {
                    name: 'CONSUMIDOR FINAL', key: 'FAF'
                }
            ],
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            filterColumns: [
                {
                    name: "replace(BH.VentaTerceroNit, '-', '')",
                    title: 'NIT Ventas a tercero',
                    value: '',
                },
                {
                    name: "BH.VentaTerceroNombre",
                    title: 'Titular Ventas a tercero',
                    value: '',
                },
                {
                    name: "BH.ID_Invoice",
                    title: 'ID de Factura',
                    value: '',
                },
                {
                    name: "CodigoGeneracion",
                    title: 'Código de generación',
                    value: '',
                },
                {
                    name: "NumeroControl",
                    title: 'Número de control',
                    value: '',
                },
                {
                    name: "CONCAT(TRIM(SU.FirstName), ' ', TRIM(SU.LastName))",
                    title: 'Usuario',
                    value: '',
                },
                {
                    name: "CONCAT(TRIM(SS.FirstName), ' ', TRIM(SS.LastName))",
                    title: 'Vendedor',
                    value: '',
                },
                {
                    name: "ID_Customer",
                    title: 'ID de Cliente',
                    value: '',
                },
                {
                    name: "InvoiceName",
                    title:  'Nombre Legal',
                    value: '',
                },
                {
                    name: "Valores",
                    title: 'Tipo de Documento',
                    value: '',
                    type: 'select',
                    options: [
                        { name: 'CONSUMIDOR FINAL', value: 'CONSUMIDOR FINAL' },
                        { name: 'CRÉDITO FISCAL',      value: 'CRÉDITO FISCAL' },
                    ]
                },
                {
                    name: "FeMhEstado",
                    title: 'Estado',
                    value: 'PROCESADO',
                    type: 'select',
                    options: [
                        { name: 'PROCESADO' ,       value: 'PROCESADO' }
                    ]
                },
                {
                    name: "startDate",
                    title: "Fecha Inicio",
                    value: "",
                    type: "date"
                },
                {
                    name: "endDate",
                    title: "Fecha Fin",
                    value: "",
                    type: "date"
                }
            ],
            filterColumns2: [
                {
                    name: "bidad.ID_Invoice",
                    title: 'ID de Factura',
                    value: '',
                },
                {
                    name: "bidad.IdentificacionCodigoGeneracion",
                    title: 'Código de generación',
                    value: '',
                },
                {
                    name: "bidad.IdentificacionNumeroControl",
                    title: 'Número de control',
                    value: '',
                },
                {
                    name: "bidad.ReceptorNombre",
                    title:  'Nombre Legal',
                    value: '',
                },
                {
                    name: "startDateIFE",
                    title: "Fecha Inicio",
                    value: "",
                    type: "date"
                },
                {
                    name: "endDateIFE",
                    title: "Fecha Fin",
                    value: "",
                    type: "date"
                }
            ],
            isCustomerSelected: false,
            rules:{
                required: (v) => (v !== null && v !== undefined && v !== '') || 'Este campo es requerido.',
                nit: (v)=> !v || /^([0-9]{14}|[0-9]{9})$/.test(v) || 'Este campo puede contener un DUI o NIT, debe tener 9 o 14 dígitos',
                nrc: (v)=> !v || /^[0-9]{1,8}$/.test(v) || 'NRC debe tener entre 1 y 8 dígitos',
                email: (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Email inválido.',
                telefono: (v) => !v || /^[0-9+;]{8,8}$/.test(v) || 'Teléfono inválido debe contener 8 digitos.',
                codigoMH: (v) => !v || /^[MSB][0-9]{3}$/.test(v) || 'Código MH debe iniciar con M, S o B seguido de 3 números.',
                puntoVentaMH: (v) => !v || /^P[0-9]{3}$/.test(v) || 'Punto de venta MH debe iniciar con P seguido de 3 números.',
                minLength: (min) => (v) => !v || v.length >= min || `Mínimo ${min} caracteres`,
                maxLength: (max) => (v) => !v || v.length <= max || `Máximo ${max} caracteres`,
                max: (max) => (v) => !v || parseFloat(v) <= max || `Valor maximo ${max}`,
                min: (min) => (v) => !v || parseFloat(v) >= min || `Valor min ${min}`,
            },
            alertDialog: {
                show: false,
                type: 'warning', // success, error, warning, info
                message: ''
            },
            showInvalidAlert: false,
            invalidForm: {
                motivoInvalid: "",
                tipo: 2,
                tipoInvalid: [
                { id: 2, value: "Rescindir de la operación realizada." },
                ],
                IsReturn: false,
            },
            reloadPrint: 0,
            reloadPrintCl: 100,
        }
    },
    watch: {
        selectedBranch: function() {
            if (this.selectedBranch) {
                this.filter.ID_Branch = this.selectedBranch;
            } else {
                // Si se limpia la selección, usar la sucursal por defecto del localStorage
                this.filter.ID_Branch = JSON.parse(localStorage.getItem("user")).branch || "";
            }
            // this.getAllInvoices();
        },
        formDcl: {
            handler(newVal) {
                newVal.liquidoapagar = parseFloat( (
                        (newVal.valoroperaciones - newVal.ivapercibido - newVal.comision - newVal.ivacomision)
                    ).toFixed(2)
                )

                newVal.totalliquidar = parseFloat(newVal.liquidoapagar.toFixed(2))
            },
            deep: true
        },
        invoicesSelected: {
            handler(newVal) {
                if (!newVal || newVal.length === 0) {
                    this.cleanForm()
                    return;
                }

                const dates = newVal.map(item => this.parseDateLocal(item.InvoiceDateDF))

                const minDate = new Date(Math.min(...dates))
                const maxDate = new Date(Math.max(...dates))

                const format = (date) => {
                    const d = date.getDate().toString().padStart(2, "0");
                    const m = (date.getMonth() + 1).toString().padStart(2, "0");
                    const y = date.getFullYear();
                    return `${d}/${m}/${y}`;
                };

                this.formDcl.periodoliquidacionfechainicio = format(minDate)
                this.formDcl.periodoliquidacionfechafin = format(maxDate)
                
                let valorOperaciones = 0
                let cantidadDoc = 0
                let montoSinPercepcion = 0
                
                newVal.forEach(item => {
                    cantidadDoc++
                    valorOperaciones += parseFloat((
                            parseFloat(item.InvoiceTotalPagar)
                        ).toFixed(2)
                    )

                    montoSinPercepcion += parseFloat((
                            parseFloat(item.InvoiceTotalNoGravado) + parseFloat(item.InvoiceTotalExenta)
                        ).toFixed(2)
                    )
                });

                this.formDcl.valoroperaciones = parseFloat(valorOperaciones.toFixed(2))
                this.formDcl.montosinpercepcion = parseFloat(montoSinPercepcion.toFixed(2))
                this.formDcl.subtotal = parseFloat(valorOperaciones.toFixed(2))
                this.formDcl.cantidaddoc = cantidadDoc
                this.formDcl.iva = parseFloat( (
                        (this.formDcl.subtotal / 1.13) * 0.13
                    ).toFixed(2)
                )
                this.formDcl.montosujetopercepcionsiniva = parseFloat( (
                        this.formDcl.subtotal / 1.13
                    ).toFixed(2)
                )

                this.selectCodigoLiquidacion()
                this.calculateComision()
            },
            deep: true
        },
        invoicesSelected2: {
            handler(newVal) {
                if (!newVal || newVal.length === 0) {
                    this.cleanForm2()
                    return;
                }

                const totalnosuj = newVal.reduce(
                    (sum, inv) => sum + Number(inv.InvoiceTotalNoSuj || 0),
                    0
                )

                const totalexenta = newVal.reduce(
                    (sum, inv) => sum + Number(inv.InvoiceTotalExenta || 0),
                    0
                )

                const totalgravada = newVal.reduce(
                    (sum, inv) => sum + ( inv.InvoiceType == 'FCF' ?  Number((inv?.InvoiceTotalGravada - inv?.InvoiceTotalIva) || 0) : Number(inv.InvoiceTotalGravada || 0) ),
                    0
                )

                //const subtotalventas = newVal.reduce(
                //    (sum, inv) => sum + Number(inv.InvoiceSubTotalVentas || 0),
                //    0
                //)

                const montototaloperacion = newVal.reduce(
                    (sum, inv) => sum + Number(inv.InvoiceMontoTotalOperacion || 0),
                    0
                )

                const ivaperci = newVal.reduce(
                    (sum, inv) => sum + Number(inv?.InvoiceIvaPerce1  || 0),
                    0
                )

                const total = newVal.reduce(
                    (sum, inv) => sum + Number((inv?.InvoiceTotalPagar - inv?.InvoiceTotalNoGravado) || 0),
                    0
                )

                let subtotalventas = Number((totalnosuj + totalexenta + totalgravada).toFixed(2))
                //let montototaloperacion = Number((subtotalventas + ivaperci + total).toFixed(2))

                this.formCl.totalnosuj = Number(totalnosuj.toFixed(2))
                this.formCl.totalexenta = Number(totalexenta.toFixed(2))
                this.formCl.totalgravada = Number(totalgravada.toFixed(2))
                this.formCl.subtotalventas = Number(subtotalventas.toFixed(2))
                this.formCl.montototaloperacion = Number(montototaloperacion.toFixed(2))
                this.formCl.ivaperci = Number(ivaperci.toFixed(2))
                this.formCl.total = Number(total.toFixed(2))
                this.formCl.totalenletras = numberToText(this.formCl.total);
            },
            deep: true,
        }
    },
    computed: {
        ...mapGetters(["getCatalogMH", "activeWindowUuid"]),
        activities() {
            return this.getCatalogMH("ActividadEconomica");
        },
        bulkInvoicesCount() {
            return this.bulkLiquidationInvoices.length;
        },
        selectedInvoiceIds() {
            const arr = this.invoicesSelected ?? [];
            return new Set(arr.map(i => i.id_invoice ?? i.ID_Invoice));
        },
        selectedInvoiceIds2() {
            const arr = this.invoicesSelected2 ?? [];
            return new Set(arr.map(i => i.id_invoice ?? i.ID_Invoice));
        }
    },
    mounted() {
        this.cleanForm();
        this.cleanForm2();
        this.getBranches();
        this.getAllCostumers();
        this.getAllInvoicesForLiquidation();
        this.getInvoicesLiquidationType();
    },
    methods: {
        bulkDateFilterHandler(filteredData) {
            this.bulkLiquidationInvoices = Array.isArray(filteredData)
                ? filteredData
                : (filteredData?.data || []);
        },
        onExporting(e, gridType) {
            const fileName = gridType === "invoices"
                ? "Estado de facturas liquidadas"
                : "Listado de facturas de liquidacion";
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet(fileName);

            exportDataGrid({
                component: e.component,
                worksheet,
                topLeftCell: { row: 4, column: 1 },
                customizeCell: ({ gridCell, excelCell }) => {
                    if (gridCell.rowType !== "data" || !gridCell.column) {
                        return;
                    }

                    if (gridCell.column.caption === "Comp. Contable") {
                        excelCell.value = gridCell.data.BIDR_EsDcl ? "GENERADO" : "PENDIENTE";
                    }

                    if (gridCell.column.caption === "Comp. Liquidación") {
                        excelCell.value = gridCell.data.BIDR_EsCl ? "GENERADO" : "PENDIENTE";
                    }
                    if (gridCell.column.caption === "Tipo de Factura") {
                        if (gridCell.data.IdentificacionTipoDte == "08") {
                            excelCell.value = "COMPROBANTE DE LIQUIDACION";
                        }

                        if (gridCell.data.IdentificacionTipoDte == "09") {
                            excelCell.value = "COMPROBANTE CONTABLE DE LIQUIDACION";
                        }
                    }
                },
            }).then((cellRange) => {
                const headerRow = worksheet.getRow(2);
                headerRow.height = 30;
                worksheet.mergeCells(2, 1, 2, 8);

                headerRow.getCell(1).value = fileName;
                headerRow.getCell(1).font = { name: "Segoe UI Light", size: 22 };
                headerRow.getCell(1).alignment = { horizontal: "center" };

                const footerRowIndex = cellRange.to.row + 2;
                const footerRow = worksheet.getRow(footerRowIndex);
                worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

                footerRow.getCell(1).value = "-";
                footerRow.getCell(1).font = { color: { argb: "BFBFBF" }, italic: true };
                footerRow.getCell(1).alignment = { horizontal: "right" };
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(
                        new Blob([buffer], { type: "application/octet-stream" }),
                        `${fileName}.xlsx`
                    );
                });
            });

            e.cancel = true;
        },
        onRowPrepared(e) {
            if (e.rowType !== 'data') return;
            const estado = e.data.FeMhEstado;
                
            if (estado === 'RECHAZADO') {
                e.rowElement.classList.add('row-rechazado');
            } 
            else if (estado === 'CONTINGENCIA') {
                e.rowElement.classList.add('row-contingencia');
            }
            else if (estado === 'INVALIDADO') {
                e.rowElement.classList.add('row-invalidado');
            }
        },
        invalidDTE(invForm) {
            invForm.header = {
                ID_Invoice: this.invoiceToInvalid.ID_Invoice,
                InvoiceDate: this.invoiceToInvalid.InvoiceDate,
                InvoiceType: this.invoiceToInvalid.InvoiceType,
            };
            
            if (!invForm.motivoInvalid || invForm.motivoInvalid.length < 5) {
                this.showInvalidAlert = false;
                this.showAlert(
                "warning",
                "Advertencia",
                "El motivo debe tener al menos 5 caracteres para poderse invalidar",
                "showInvalid"
                );
                return;
            }

            if (invForm.tipo == 2) {
                this.showInvalidAlert = false;
                this.loading = true;
                this.$API.invoices
                .invalidInvoiceDclYCl({
                    ID_Invoice: this.invoiceToInvalid.ID_Invoice,
                    InvalidForm: invForm,
                    ID_Business: this.invoiceToInvalid.ID_Business,
                    ID_Branch: this.invoiceToInvalid.ID_Branch,
                    user: JSON.parse(localStorage.getItem("user")).id,
                })
                .then((response) => {
                    this.loading = false;
                    if (response.estado == "PROCESADO") {
                        let mensaje =
                            "Se ha realizado y procesado la invalidación <br/><br/>";
                        mensaje += "Estado: " + response.estado + "<br/>";
                        mensaje +=
                            "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
                        mensaje += "Observaciones DTE: <br/>";
                        
                        if (response.observaciones.length == 0) {
                            mensaje += "- Ninguna observación <br/>";
                        } else {
                            for (let i = 0; i < response.observaciones.length; i++) {
                            mensaje += "- " + response.observaciones[i] + "<br/>";
                            }
                        }

                        this.showAlert(
                            "successHtml",
                            "Invalidación realizada",
                            mensaje,
                            "reloadInvoices"
                        );
                    } else {
                        let mensaje =
                            "Se ha rechazado la invalidación, tomar en cuenta las observaciones del Ministerio de Hacienda y realizarla de nuevo.<br/><br/>";
                        mensaje += "Estado: " + response.estado + "<br/>";
                        mensaje +=
                            "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
                        mensaje += "Observaciones DTE: <br/>";
                        
                        if (response.observaciones.length == 0) {
                            mensaje += "- Ninguna observación <br/>";
                        } else {
                            for (let i = 0; i < response.observaciones.length; i++) {
                            mensaje += "- " + response.observaciones[i] + "<br/>";
                            }
                        }

                        this.showAlert(
                            "successHtml", 
                            "Invalidación rechazada", 
                            mensaje, 
                            "reloadInvoices"
                        );
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.showInvalidAlert = false;
                    let message =
                    "Ocurrio un error crítico al realizar la invalidación. Luego de 3 intentos sin éxito contáctese con el administrador. ";
                    message += "" + JSON.stringify(err);
                    this.showAlert("warning", "Advertencia", message);
                });
            }
        },
        displayInvalidForm(data) {
            this.invoiceToInvalid = data
            this.showInvalidAlert = true
        },
        isSelected(id_invoice){
            if (id_invoice == null) return false;
            return this.selectedInvoiceIds.has(id_invoice);
        },
        isSelected2(id_invoice){
            if (id_invoice == null) return false;
            return this.selectedInvoiceIds2.has(id_invoice);
        },
        calculateOperation1() {
            this.formDcl.subtotal = parseFloat(parseFloat(this.formDcl.valoroperaciones).toFixed(2))

            this.formDcl.iva = parseFloat( (
                    (this.formDcl.subtotal / 1.13) * 0.13
                ).toFixed(2)
            )
            
            this.formDcl.montosujetopercepcionsiniva = parseFloat( (
                    this.formDcl.subtotal / 1.13
                ).toFixed(2)
            )    

            this.selectCodigoLiquidacion()
            this.calculateComision()
        },
        calculateOperation2() {
            this.formDcl.valoroperaciones = parseFloat(parseFloat(this.formDcl.subtotal).toFixed(2))

            this.formDcl.iva = parseFloat( (
                    (this.formDcl.subtotal / 1.13) * 0.13
                ).toFixed(2)
            )
            
            this.formDcl.montosujetopercepcionsiniva = parseFloat( (
                    this.formDcl.subtotal / 1.13
                ).toFixed(2)
            )
            
            this.selectCodigoLiquidacion()
            this.calculateComision()
        },
        async displayPrinter(data){
            try {
                if (data.data.IdentificacionTipoDte == '09') {
                    this.print = { data: data.data, show: true };
                }

                if (data.data.IdentificacionTipoDte == '08') {
                    const invoices = await this.$API.liquidaciones.getInvoicesByDocRelated({ ID_Invoice: data.data.ID_Invoice })

                    if (invoices.length > 0) {
                        this.print2 = { data: data.data, invoices: invoices, show: true}
                    }
                }
                
                
            } catch (error) {
                console.log(error);
            }
        },
        cleanData() {
            this.cleanForm()
            this.cleanInvoicesSelected()
            this.getAllInvoicesForLiquidation();
        },
        cleanData2() {
            this.cleanForm2()
            this.cleanInvoicesSelected2()
            this.getAllInvoicesForLiquidation();
        },
        cleanForm() {
            const format = () => {
                const date = new Date()
                const d = date.getDate().toString().padStart(2, "0");
                const m = (date.getMonth() + 1).toString().padStart(2, "0");
                const y = date.getFullYear();
                return `${d}/${m}/${y}`;
            };

            let user = JSON.parse(localStorage.getItem("user"))
            
            this.formDcl = {
                fechafactura: format(),
                username: user.firstName + " " + user.lastName,
                userdui: user.userdui,
                periodoliquidacionfechainicio: format(),
                periodoliquidacionfechafin: format(),
                valoroperaciones: 0,
                porcentajeretencioniva: 0,
                cantidaddoc: null,
                subtotal: 0,
                iva: 0,
                montosujetopercepcionsiniva: 0,
                ivapercibido: 0,
                porcentajecomision: 0,
                comision: 0,
                ivacomision: 0,
                liquidoapagar: 0,
                montosinpercepcion: 0,
                totalliquidar: 0
            }
        },
        cleanForm2() {
            const format = () => {
                const date = new Date()
                const d = date.getDate().toString().padStart(2, "0");
                const m = (date.getMonth() + 1).toString().padStart(2, "0");
                const y = date.getFullYear();
                return `${d}/${m}/${y}`;
            };

            let user = JSON.parse(localStorage.getItem("user"))
            
            this.formCl = {
                fechafactura: format(),
                username: user.firstName + " " + user.lastName,
                userdui: user.userdui,
                periodoliquidacionfechainicio: format(),
                periodoliquidacionfechafin: format(),
                valoroperaciones: 0,
                porcentajeretencioniva: 0,
                cantidaddoc: null,
                subtotal: 0,
                iva: 0,
                montosujetopercepcionsiniva: 0,
                ivapercibido: 0,
                porcentajecomision: 0,
                comision: 0,
                ivacomision: 0,
                liquidoapagar: 0,
                montosinpercepcion: 0,
                totalliquidar: 0
            }
        },
        cleanInvoicesSelected() {
            this.invoicesSelected = []
        },
        cleanInvoicesSelected2() {
            this.invoicesSelected2 = []
        },
        showAlertDialog(message, type = 'warning') {
            this.alertDialog = {
                show: true,
                type: type,
                message: message
            };
        },
        async createComprobanteContableLiquidacion() {
            const isValid = this.$refs.formLiquidacion.validate();
            if (!isValid) {
                this.showAlertDialog(
                    "Corrija el formulario antes de generar el comprobante.",
                )
                return;
                
            }

            this.showFormDcl = !this.showFormDcl
            this.loading = true
            let codPointSale = localStorage.getItem("codPointSale")
            await this.$API.liquidaciones.posCreateComprobanteContableLiquidacion(
                { 
                    form: this.formDcl, 
                    invoices: this.invoicesSelected, 
                    codPointSale: codPointSale, 
                    id_user: JSON.parse(localStorage.getItem("user")).id 
                }
            )
            .then(response => {
                if (response.estado == "PROCESADO") {
                    let mensaje = ""
                    mensaje = "Se ha realizdo y procesado la factura.<br/><br/>"
                    mensaje += "Estado: " + response.estado + "<br/>";
                    mensaje += "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
                    mensaje += "Observaciones DTE: <br/>"
                        
                    if (response.observaciones.length == 0) {
                        mensaje += "- Ninguna observación <br/>"
                    }
                    else {
                        for (let i = 0; i < response.observaciones.length; i++) {
                            mensaje += "- " + response.observaciones[i] + "<br/>"
                        }
                    }

                    this.showAlert(
                        "successHtml",
                        "Factura generada",
                        mensaje,
                        "reloadComponent"
                    );
                }
                else {
                    let mensaje = "Se ha rechazado la factura, tomar en cuenta las observaciones del Ministerio de Hacienda y realizarla de nuevo.<br/><br/>";
                    mensaje += "Estado: " + response.estado + "<br/>";
                    mensaje += "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
                    mensaje += "Observaciones DTE: <br/>"
                    
                    if (response.observaciones.length == 0) {
                        mensaje += "- Ninguna observación <br/>"
                    }
                    else {
                        for (let i = 0; i < response.observaciones.length; i++) {
                            mensaje += "- " + response.observaciones[i] + "<br/>"
                        }
                    }

                    this.showAlert(
                        "successHtml",
                        "Factura generada",
                        mensaje
                    );
                }
                
            })
            .catch(() => {
                let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
                
                this.showAlert(
                    "warning",
                    "Advertencia",
                    message,
                )
            })
            .finally(() =>  {
                this.loading = false
                this.cleanData()
            })
        },
        async createComprobanteDeLiquidacion() {
            const isValid = this.$refs.formLiquidacion2.validate();
            if (!isValid) {
                this.showAlertDialog(
                    "Corrija el formulario antes de generar el comprobante.",
                )
                return;
                
            }

            this.showFormCl = !this.showFormCl
            this.loading = true
            let codPointSale = localStorage.getItem("codPointSale")
            await this.$API.liquidaciones.posCreateComprobanteDeLiquidacion(
                { 
                    form: this.formCl, 
                    invoices: this.invoicesSelected2, 
                    codPointSale: codPointSale, 
                    id_user: JSON.parse(localStorage.getItem("user")).id 
                }
            )
            .then(response => {
                if (response.estado == "PROCESADO") {
                    let mensaje = ""
                    mensaje = "Se ha realizdo y procesado la factura.<br/><br/>"
                    mensaje += "Estado: " + response.estado + "<br/>";
                    mensaje += "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
                    mensaje += "Observaciones DTE: <br/>"
                        
                    if (response.observaciones.length == 0) {
                        mensaje += "- Ninguna observación <br/>"
                    }
                    else {
                        for (let i = 0; i < response.observaciones.length; i++) {
                            mensaje += "- " + response.observaciones[i] + "<br/>"
                        }
                    }

                    this.showAlert(
                        "successHtml",
                        "Factura generada",
                        mensaje,
                        "reloadComponent"
                    );
                }
                else {
                    let mensaje = "Se ha rechazado la factura, tomar en cuenta las observaciones del Ministerio de Hacienda y realizarla de nuevo.<br/><br/>";
                    mensaje += "Estado: " + response.estado + "<br/>";
                    mensaje += "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
                    mensaje += "Observaciones DTE: <br/>"
                    
                    if (response.observaciones.length == 0) {
                        mensaje += "- Ninguna observación <br/>"
                    }
                    else {
                        for (let i = 0; i < response.observaciones.length; i++) {
                            mensaje += "- " + response.observaciones[i] + "<br/>"
                        }
                    }

                    this.showAlert(
                        "successHtml",
                        "Factura generada",
                        mensaje
                    );
                }
                
            })
            .catch(() => {
                let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
                
                this.showAlert(
                    "warning",
                    "Advertencia",
                    message,
                )
            })
            .finally(() =>  {
                this.loading = false
                this.cleanData2()
            })
        },
        calculatePorcentajeComision() {
            this.formDcl.porcentajecomision = parseFloat( (
                    (this.formDcl.comision / this.formDcl.montosujetopercepcionsiniva) * 100
                ).toFixed(2)
            )

            this.formDcl.ivacomision = parseFloat( (
                    (this.formDcl.comision * 0.13)
                )
            )
        },
        calculateComision() {
            if (this.formDcl.porcentajecomision) {
                this.formDcl.comision = parseFloat( (
                        this.formDcl.montosujetopercepcionsiniva * (this.formDcl.porcentajecomision / 100)
                    )
                ).toFixed(2)

                this.formDcl.ivacomision = parseFloat( (
                        (this.formDcl.comision * 0.13)
                    ).toFixed(2)
                )
            }
            else {
                this.formDcl.comision = 0
            }
        },
        selectCodigoLiquidacion() {
            if (!this.formDcl.subtotal) {
                return;
            }

            if (this.formDcl.codigoliquidacion == "22") {
                this.formDcl.ivapercibido = parseFloat( ( 
                        this.formDcl.montosujetopercepcionsiniva * 0.02
                    ).toFixed(2)
                )
                this.formDcl.porcentajeretencioniva = 0
            }

            if (this.formDcl.codigoliquidacion == "C4") {
                this.formDcl.ivapercibido = parseFloat( ( 
                        this.formDcl.montosujetopercepcionsiniva * 0.13
                    ).toFixed(2)
                )
                this.formDcl.porcentajeretencioniva = 0
            }

            if (this.formDcl.codigoliquidacion == "C9") {
                if (this.formDcl.porcentajeretencioniva) {
                    let porcentaje = parseFloat( (
                            this.formDcl.porcentajeretencioniva / 100
                        ).toFixed(2)
                    )

                    this.formDcl.ivapercibido = parseFloat( ( 
                            this.formDcl.montosujetopercepcionsiniva * porcentaje
                        ).toFixed(2)
                    )
                }
            }
        },
        parseDateLocal(str) {
            const [y, m, d] = str.split("-");
            return new Date(y, m - 1, d);
        },
        removeFromInvoicesToLiquidation(data) {
            const index = this.invoicesSelected.findIndex(x => x.uuid === data.uuid);

            if (index !== -1) {
                this.invoicesSelected.splice(index, 1);
            }
        },
        removeFromInvoicesToLiquidation2(data) {
            const index = this.invoicesSelected2.findIndex(x => x.uuid === data.uuid);

            if (index !== -1) {
                this.invoicesSelected2.splice(index, 1);
            }
        },
        addToProccesInvoiceForLiquidation(data) {
            const uuid = generateUUID();

            const exist = this.invoicesSelected.some(x => x.ID_Invoice === data.ID_Invoice)

            if (!exist) {
                this.invoicesSelected.push({uuid: uuid, ...data})
            }
            else {
                this.showAlert(
                    "warning",
                    "Advertencia", 
                    "La factura ya ha sido agregada para la generación del comprobante contable"
                )
            }
            
        },
        addToProccesInvoiceForLiquidation2(data) {
            const uuid = generateUUID();

            const exist = this.invoicesSelected2.some(x => x.ID_Invoice === data.ID_Invoice)

            if (!exist) {
                this.invoicesSelected2.push({uuid: uuid, ...data})
            }
            else {
                this.showAlert(
                    "warning",
                    "Advertencia", 
                    "La factura ya ha sido agregada para la generación del comprobante de liquidación"
                )
            }
            
        },
        clearFilter(){
            this.isFiltered = false;
            this.getAllInvoicesForLiquidation();
        },
        clearFilterLiquidations() {
            this.isFiltered2 = false;
            this.getAllInvoicesLiquidationType();
        },
        resetBulkLiquidationInvoices() {
            this.bulkLiquidationInvoices = [];
        },
        formatInvoiceFields() {
            const dictionary = {
                '00': "Prueba",
                '01': "Producción"
            };
            const { Currency } = JSON.parse(localStorage.getItem('branch'));
            for(const index in this.invoices) {
                const { IdentificacionHorEmi, InvoiceType, SystemDateInsert, IdentificacionTipoDteDesc } = this.invoices[ index ];
                
                this.invoices[index].AmbienteToShow = dictionary[this.invoices[index].IdentificacionAmbiente];
                this.invoices[index].InvoiceTotalPagarToShow = `${Currency}${numberWithCommas(this.invoices[index].InvoiceTotalPagar.toFixed(2))}`;

                if( InvoiceType === 'TCKS' ) {
                    this.invoices[ index ].HorEmi = this.formatDateToHour(SystemDateInsert);
                    this.invoices[ index ].TipoDocumento = "TICKET";
                } else {
                    if( IdentificacionTipoDteDesc != null ) {
                        this.invoices[ index ].TipoDocumento = IdentificacionTipoDteDesc;
                    } else {
                        this.invoices[ index ].TipoDocumento = "";
                    }
                    if( IdentificacionHorEmi != null ) {
                        this.invoices[ index ].HorEmi = IdentificacionHorEmi;
                    } else { 
                        this.invoices[ index ].HorEmi = "";
                    }
                }
            }
        },
        filterHandler(response) {
            this.isFiltered = true;
            this.invoices = [...response];
            this.formatInvoiceFields();
        },
        filterHandlerLiquidations(response) {
            this.isFiltered2 = true;
            this.invoicesDclAndCl = [...response]
        },
        changueValueactivity() {
            this.formDcl.descactividad = this.activities.find(
                (act) => act.Codigo == this.formDcl.codactividad
            ).Valores;
        },
        async getDuiMask() {
            this.formDcl.dui = await duiMask(this, this.formDcl.dui);
        },
        async getNITMask(e) {
            if (e.which === 8) return false;
            this.formDcl.legalnit = await nitMaskHandlingHomologation(
                this,
                this.formDcl.legalnit
            );
        },
        async getNRCMask() {
            this.formDcl.legalnrc = await nrcMask(this, this.formDcl.legalnrc);
        },
        async customerSelected(data) {
            this.isCustomerSelected = true;
            if (
                !this.customersList.find(
                (current) => current.ID_Customer === data.ID_Customer
                )
            ) {
                if (data.Is_a_business) {
                data.itemText = data.BusinessName;
                } else {
                data.itemText = data.LegalName;
                }
                this.customersList.push(data);
            }
            Object.keys(data).map((el) => {
                Vue.set(this.formDcl, el.replace("_", "").toLowerCase(), data[el]);
            });

            if (data.Is_a_Table) {
                this.formDcl.legalname = "CLIENTES VARIOS"
            }
            this.formDcl.dui && (this.form.dui = this.formDcl.dui.replace('-', ''));
            this.formDcl.legalnrc &&
                (this.formDcl.legalnrc = this.formDcl.legalnrc.replace('-', ''));
            this.formDcl.legalnit &&
                (this.formDcl.legalnit = 
                this.formDcl.legalnit.replace('-', ''));
        },
        async customerSelected2(data) {
            this.isCustomerSelected = true;
            if (
                !this.customersList.find(
                (current) => current.ID_Customer === data.ID_Customer
                )
            ) {
                if (data.Is_a_business) {
                data.itemText = data.BusinessName;
                } else {
                data.itemText = data.LegalName;
                }
                this.customersList.push(data);
            }
            Object.keys(data).map((el) => {
                Vue.set(this.formCl, el.replace("_", "").toLowerCase(), data[el]);
            });

            if (data.Is_a_Table) {
                this.formCl.legalname = "CLIENTES VARIOS"
            }
            this.formCl.dui && (this.form.dui = this.formCl.dui.replace('-', ''));
            this.formCl.legalnrc &&
                (this.formCl.legalnrc = this.formCl.legalnrc.replace('-', ''));
            this.formCl.legalnit &&
                (this.formCl.legalnit = 
                this.formCl.legalnit.replace('-', ''));
        },
        async customerSelectOnchange(event) {
            try {
                const foundCustomer = this.customersList.find(
                    (current) => current.ID_Customer === event
                );
                if (foundCustomer) {
                    this.customerSelected(
                        this.customersList.find((current) => current.ID_Customer === event)
                    );
                }
            } catch (error) {
                console.log(error);
                this.showAlert(
                "error",
                "Error",
                `Ocurrió el siguiente error al intentar seleccionar un usuario ${error.message}`
                );
            }
        },
        async customerSelectOnchange2(event) {
            try {
                const foundCustomer = this.customersList.find(
                    (current) => current.ID_Customer === event
                );
                if (foundCustomer) {
                    this.customerSelected2(
                        this.customersList.find((current) => current.ID_Customer === event)
                    );
                }
            } catch (error) {
                console.log(error);
                this.showAlert(
                "error",
                "Error",
                `Ocurrió el siguiente error al intentar seleccionar un usuario ${error.message}`
                );
            }
        },
        getBranches() {
            this.$API.branches
                .findBranches(JSON.parse(localStorage.getItem("user")).businessid)
                .then((data) => {
                    this.branches = data;

                    // Establecer la sucursal del localStorage como seleccionada por defecto
                    const currentUserBranch = JSON.parse(localStorage.getItem("user")).branch || "";
                    this.selectedBranch = currentUserBranch;
                    this.filter.ID_Branch = currentUserBranch;

                    // Obtener el nombre de la sucursal actual
                    const currentBranchData = data.find(branch => branch.ID_Branch == currentUserBranch);
                    if (currentBranchData) {
                        this.currentBranch = currentBranchData.BranchName;
                    }
                })
                .catch((err) => {
                    console.log("Error al obtener sucursales:", err);
                    this.$toasted.error("Error al cargar las sucursales");
                });
        },
        onBranchChange(e) {
            this.selectedBranch = e;
            // Este método se ejecuta cuando cambia la sucursal seleccionada
            if (this.selectedBranch) {
                const selectedBranchData = this.branches.find(branch => branch.ID_Branch == this.selectedBranch);
                if (selectedBranchData) {
                    this.currentBranch = selectedBranchData.BranchName;
                }
                this.filter.ID_Branch = this.selectedBranch;
            } else {
                // Si se limpia la selección (botón X), volver a la sucursal por defecto del localStorage
                const defaultBranch = JSON.parse(localStorage.getItem("user")).branch || "";
                this.selectedBranch = defaultBranch;
                this.filter.ID_Branch = defaultBranch;
                
                const defaultBranchData = this.branches.find(branch => branch.ID_Branch == defaultBranch);
                if (defaultBranchData) {
                    this.currentBranch = defaultBranchData.BranchName;
                }
            }
        },
        changeLoading(response) {
            this.loading = response
        },
        onShowAllRecordsChange(value) {
            this.showAllRecords = value;
            // this.getAllInvoices();
        },
        async getAllCostumers() {
            try {
                const customers =
                await this.$API.customers.getCustomersPOSCreateInvoice(this.search);
                this.customersList = this.assignCustomersList(customers);
            } catch (error) {
                this.showAlert(
                    "error",
                    "Error!",
                    `Ha ocurrido el siguiente error al intentar obtener todos los clientes de este negocio ${error.message}`
                );
            }
        },
        assignCustomersList(customers) {
            return customers.map((current) => {
                if (current.Is_a_business) {
                current.itemText = current.BusinessName;
                } else {
                current.itemText = current.LegalName;
                }
                return current;
            });
        },
        async closeAlert() {
            this.alert.show = false;

            if (this.alert.options == "reloadComponent") {
                this.cleanData() 
            }

            if (this.alert.options == "reloadInvoices") {
                this.clearFilterLiquidations()
            }
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        updateCustomersLIst(payload) {
            this.customersList = this.assignCustomersList(payload);
        },
        getAllInvoicesForLiquidation() {
            this.loading = true
            const filterWithLimit = {
                ...this.filter,
                showAllRecords: this.showAllRecords
            };
            this.$API.liquidaciones.getInvoicesForLiquidation(filterWithLimit)
                .then(response => {
                    this.loading = false
                    this.invoices = response
                    this.formatInvoiceFields();    
                })
                .catch(error => {
                    console.log(error)
                    this.loading = false
                })
        },
        getAllInvoicesLiquidationType() {
            this.loading = true
            const filterWithLimit = {
                ...this.filter2,
                showAllRecords: this.showAllRecords
            };
            this.$API.liquidaciones.getInvoicesLiquidationType(filterWithLimit) 
                .then(response => {
                    this.loading = false
                    this.invoicesDclAndCl = response
                })
                .catch(error => {
                    console.log(error)
                    this.loading = false
                })
        }
    }
}
</script>

<style scoped> 
.hoveredDiv{
    cursor: pointer;
}
.hoveredDiv:hover{
    background-color: #4e9ed3 !important;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2) !important;
}
.hoveredDiv2{
    cursor: pointer;
}
.hoveredDiv2:hover{
    background-color: rgb(41, 182, 147) !important;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2) !important;
}
.btn-add{
    background-color: #00A178 !important;
    color: white;
}
.btnclean {
  background-color: #f29d35 !important;
  color: white;
}

.btnsave {
    background-color: #3498db !important;
    color: white;
}
.btndisable {
  background-color: #41464c !important;
  color: white;
}
.background {
    background: white !important;
    color: white;
}
.btn-wrap-text {
    padding: 10px 16px; 
    width: fit-content;
    font-weight: 500;
    font-size:0.875rem;
    align-items: center;
    border-radius: 4px;
    display: inline-flex;
    flex: 0 0 auto;
    font-weight: 500;
    letter-spacing: 0.0892857143em;
    justify-content: center;
    outline: 0;
    position: relative;
    text-decoration: none;
    text-indent: 0.0892857143em;
    text-transform: uppercase;
    transition-duration: 0.28s;
    transition-property: box-shadow, transform, opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
   
}
@media screen and (max-width: 900px) {
    .item {
        padding-bottom: 20px; /* Añade padding en la parte inferior en pantallas más pequeñas */
    }
}
@media screen and (max-width: 521px) {
    .btn-padding {
        margin-bottom: 20px; 
    }
    .btn-wrap-text {
        text-align: center; 
        line-height: 1.5; 
        width: 100%; 
    }
}
::v-deep .row-rechazado {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}
::v-deep .row-contingencia {
    background-color: #cce5ff !important;
    color: #004085 !important;
}
::v-deep .row-invalidado {
    background-color: #fff3cd !important;
    color: #856404 !important;
}
</style>
